
export interface IFact {
	id: number;
	property?: number;
	account?: string;
	type: string;
	context: any;
}

export interface IFactsByType {
	[type: string]: IFact;
}

export interface IFactsByProperty {
	[property: number]: IFactsByType;
}

export enum PropertyFacts {
	PROPERTY_ONBOARD_COMPLETENESS = 'property_onboard_completeness',
	COVID19_PRICING_DISCOUNTED = 'covid19_pricing_discounted',
	COVID19_MIN_NIGHT_STAY_UPDATED = 'covid19_min_night_stay_updated',
	COVID19_ADVANCED_BOOKINGS_UPDATED = 'covid19_advanced_bookings_updated',
}

export enum AccountFacts {
	COVID19_CANCELLATION_PREFERENCE_UPDATED = 'covid19_cancellation_preference_updated',
	ONBOARD_COMPLETE = 'ONBOARD_COMPLETE'
}

export interface IOnboardCompleteFact extends IFact {
	context: { complete: boolean, propertyId: number; };
}
